import React from "react";
import LinkButton from "../../LinkButton/LinkButton";
import styles from "./AuditEntryRow.module.sass";
const AuditEntryRow = ({
  data
}) => {
  const {
    name,
    description,
    type,
    severity,
    total,
    verified
  } = data || {};
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["row"]} ${styles[`severity-${severity}`]}`
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("h5", null, name || "N/A", ` (${total} Occurrences)`), /*#__PURE__*/React.createElement("small", null, description || "N/A")), /*#__PURE__*/React.createElement("span", {
    className: styles["align-center"]
  }, /*#__PURE__*/React.createElement(LinkButton, {
    label: type
  })), /*#__PURE__*/React.createElement("div", {
    className: `${styles["align-center"]} ${styles[verified ? "valid" : "invalid"]}`
  }, /*#__PURE__*/React.createElement("small", null, verified, " / ", total)));
};
AuditEntryRow.header = [{
  label: ["Critical Faults"],
  align: "left"
}, {
  label: ["Category"],
  align: "center"
}, {
  label: ["Status"],
  align: "center"
}];
export default AuditEntryRow;